if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const spinner = this.querySelector('.loading__spinner');

        if (spinner) {
          spinner.classList.remove('hidden');
        }

        const config = fetchConfig('javascript');

        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart
              .getSectionsToRender()
              .map((section) => section.id)
          );

          formData.append(
            'sections_url',
            window.location.pathname
          );

          this.cart.setActiveElement(
            document.activeElement
          );
        }

        config.body = formData;

        fetch(
          `${routes.cart_add_url}`,
          config
        )
          .then((response) => response.json())

          .then((response) => {

            if (response.status) {

              publish(
                PUB_SUB_EVENTS.cartError,
                {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors:
                    response.errors ||
                    response.description,
                  message: response.message,
                }
              );

              this.handleErrorMessage(
                response.description
              );

              const soldOutMessage =
                this.submitButton.querySelector(
                  '.sold-out-message'
                );

              if (!soldOutMessage) {
                return;
              }

              this.submitButton.setAttribute(
                'aria-disabled',
                true
              );

              this.submitButtonText.classList.add(
                'hidden'
              );

              soldOutMessage.classList.remove(
                'hidden'
              );

              this.error = true;

              return;

            } else if (!this.cart) {

              window.location =
                window.routes.cart_url;

              return;
            }

            /* =====================================================
               FLY-TO-CART
               STARTET NUR NACH ERFOLGREICHEM HINZUFÜGEN
               ===================================================== */

            this.flyProductToCart();

            const startMarker =
              CartPerformance.createStartingMarker(
                'add:wait-for-subscribers'
              );

            if (!this.error) {

              publish(
                PUB_SUB_EVENTS.cartUpdate,
                {
                  source: 'product-form',
                  productVariantId:
                    formData.get('id'),
                  cartData:
                    response,
                }
              ).then(() => {

                CartPerformance.measureFromMarker(
                  'add:wait-for-subscribers',
                  startMarker
                );

              });

            }

            this.error = false;

            const quickAddModal =
              this.closest(
                'quick-add-modal'
              );

            if (quickAddModal) {

              document.body.addEventListener(
                'modalClosed',
                () => {

                  setTimeout(() => {

                    CartPerformance.measure(
                      'add:paint-updated-sections',
                      () => {

                        this.cart.renderContents(
                          response
                        );

                      }
                    );

                  });

                },
                {
                  once: true
                }
              );

              quickAddModal.hide(true);

            } else {

              CartPerformance.measure(
                'add:paint-updated-sections',
                () => {

                  this.cart.renderContents(
                    response
                  );

                }
              );
            }
          })

          .catch((e) => {

            console.error(e);

          })

          .finally(() => {

            this.submitButton.classList.remove(
              'loading'
            );

            if (
              this.cart &&
              this.cart.classList.contains(
                'is-empty'
              )
            ) {

              this.cart.classList.remove(
                'is-empty'
              );
            }

            if (!this.error) {

              this.submitButton.removeAttribute(
                'aria-disabled'
              );

            }

            if (spinner) {

              spinner.classList.add(
                'hidden'
              );

            }

            CartPerformance.measureFromEvent(
              'add:user-action',
              evt
            );

          });
      }


      /* =========================================================
         FLY-TO-CART
         PRODUKTBILD STARTET AM "IN DEN WARENKORB"-BUTTON
         ========================================================= */

      flyProductToCart() {

        const cartIcon =
          document.querySelector(
            '#cart-icon-bubble'
          );

        if (!cartIcon) {
          return;
        }

        /*
         * Produktbild suchen.
         * Das Bild wird nur als Quelle für den kleinen
         * fliegenden Klon verwendet.
         */

        const productSection =
          this.closest(
            '.product, product-info, .product-card-wrapper, .card-wrapper, quick-add-modal'
          );

        let productImage = null;

        if (productSection) {

          productImage =
            productSection.querySelector(
              'img:not([loading="lazy"]), img'
            );

        }

        /*
         * Fallback, falls das Bild außerhalb
         * des Product-Form-Containers liegt.
         */

        if (!productImage) {

          productImage =
            document.querySelector(
              '.product__media img, .product-media-container img, .product img'
            );

        }

        if (!productImage) {
          return;
        }

        /*
         * NEU:
         * Startposition kommt vom
         * "In den Warenkorb"-Button.
         */

        const buttonRect =
          this.submitButton.getBoundingClientRect();

        /*
         * Zielposition ist das Warenkorb-Symbol
         * im Sticky Header.
         */

        const cartRect =
          cartIcon.getBoundingClientRect();

        /*
         * Produktbild klonen.
         * Das echte Produktbild wird NICHT verändert.
         */

        const flyingImage =
          productImage.cloneNode(true);

        flyingImage.removeAttribute(
          'srcset'
        );

        flyingImage.removeAttribute(
          'sizes'
        );

        flyingImage.removeAttribute(
          'loading'
        );

        flyingImage.setAttribute(
          'aria-hidden',
          'true'
        );

        /*
         * Startgröße des fliegenden Produktbildes.
         */

        const startSize = 90;

        /*
         * Exakt mittig auf dem
         * "In den Warenkorb"-Button starten.
         */

        const startLeft =
          buttonRect.left +
          (buttonRect.width / 2) -
          (startSize / 2);

        const startTop =
          buttonRect.top +
          (buttonRect.height / 2) -
          (startSize / 2);

        flyingImage.style.position =
          'fixed';

        flyingImage.style.left =
          `${startLeft}px`;

        flyingImage.style.top =
          `${startTop}px`;

        flyingImage.style.width =
          `${startSize}px`;

        flyingImage.style.height =
          `${startSize}px`;

        flyingImage.style.objectFit =
          'contain';

        flyingImage.style.zIndex =
          '2147483646';

        flyingImage.style.pointerEvents =
          'none';

        flyingImage.style.margin =
          '0';

        flyingImage.style.padding =
          '0';

        flyingImage.style.border =
          '0';

        flyingImage.style.borderRadius =
          '10px';

        flyingImage.style.background =
          '#ffffff';

        flyingImage.style.boxShadow =
          '0 8px 24px rgba(0,0,0,0.18)';

        flyingImage.style.opacity =
          '1';

        flyingImage.style.transform =
          'translate3d(0,0,0) scale(1)';

        /*
         * 1,4 Sekunden Flugzeit.
         */

        flyingImage.style.transition =
          [
            'left 1.4s cubic-bezier(0.22, 0.8, 0.3, 1)',
            'top 1.4s cubic-bezier(0.22, 0.8, 0.3, 1)',
            'width 1.4s cubic-bezier(0.22, 0.8, 0.3, 1)',
            'height 1.4s cubic-bezier(0.22, 0.8, 0.3, 1)',
            'opacity 1.4s ease',
            'transform 1.4s ease'
          ].join(', ');

        document.body.appendChild(
          flyingImage
        );

        /*
         * Browser zeichnet zuerst die Startposition
         * auf dem Button.
         */

        requestAnimationFrame(() => {

          requestAnimationFrame(() => {

            /*
             * Am Warenkorb wird das Produktbild
             * sehr klein.
             */

            const targetSize = 28;

            const targetLeft =
              cartRect.left +
              (cartRect.width / 2) -
              (targetSize / 2);

            const targetTop =
              cartRect.top +
              (cartRect.height / 2) -
              (targetSize / 2);

            flyingImage.style.left =
              `${targetLeft}px`;

            flyingImage.style.top =
              `${targetTop}px`;

            flyingImage.style.width =
              `${targetSize}px`;

            flyingImage.style.height =
              `${targetSize}px`;

            flyingImage.style.opacity =
              '0.25';

            flyingImage.style.transform =
              'translate3d(0,-8px,0) scale(0.65)';

          });

        });

        /*
         * Kurz vor Ende der Fluganimation
         * reagiert das Warenkorb-Symbol.
         */

        setTimeout(() => {

          this.ensureFlyToCartStyles();

          cartIcon.classList.add(
            'hs-cart-bump'
          );

          setTimeout(() => {

            cartIcon.classList.remove(
              'hs-cart-bump'
            );

          }, 350);

        }, 1250);

        /*
         * Produktbild nach Abschluss
         * der Animation entfernen.
         */

        setTimeout(() => {

          flyingImage.remove();

        }, 1500);
      }


      /* =========================================================
         WARENKORB-SYMBOL KURZ ANIMIEREN
         ========================================================= */

      ensureFlyToCartStyles() {

        if (
          document.getElementById(
            'hs-fly-cart-style'
          )
        ) {
          return;
        }

        const style =
          document.createElement(
            'style'
          );

        style.id =
          'hs-fly-cart-style';

        style.textContent = `

          #cart-icon-bubble.hs-cart-bump {
            animation:
              hsCartBump
              0.35s ease !important;
          }

          @keyframes hsCartBump {

            0% {
              transform:
                scale(1);
            }

            45% {
              transform:
                scale(1.18);
            }

            100% {
              transform:
                scale(1);
            }

          }

        `;

        document.head.appendChild(
          style
        );
      }


      /* =========================================================
         ORIGINAL FEHLERMELDUNGEN
         ========================================================= */

      handleErrorMessage(
        errorMessage = false
      ) {

        if (this.hideErrors) {
          return;
        }

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (
          !this.errorMessageWrapper
        ) {
          return;
        }

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (errorMessage) {

          this.errorMessage.textContent =
            errorMessage;

        }
      }


      /* =========================================================
         ORIGINAL SUBMIT BUTTON
         ========================================================= */

      toggleSubmitButton(
        disable = true,
        text
      ) {

        if (disable) {

          this.submitButton.setAttribute(
            'disabled',
            'disabled'
          );

          if (text) {

            this.submitButtonText.textContent =
              text;

          }

        } else {

          this.submitButton.removeAttribute(
            'disabled'
          );

          this.submitButtonText.textContent =
            window.variantStrings.addToCart;

        }
      }


      /* =========================================================
         ORIGINAL VARIANT ID
         ========================================================= */

      get variantIdInput() {

        return this.form.querySelector(
          '[name=id]'
        );

      }
    }
  );
}